import { useTranslation } from "next-i18next";

import styles from "./PaymentError.module.scss";

export const PaymentErrors = {
  ACTIVE_SUBSCRIPTION_BLOCKING: "ACTIVE_SUBSCRIPTION_BLOCKING",
  CUSTOMER_COUNTRY_NOT_ALLOWED: "CUSTOMER_COUNTRY_NOT_ALLOWED",
  COUPON_CODE_INVALID: "COUPON_CODE_INVALID",
  POST_SUBSCRIPTION_SWITCHES__PAYMENT_METHOD_NOT_FOUND:
    "POST_SUBSCRIPTION_SWITCHES__PAYMENT_METHOD_NOT_FOUND",
};

interface PaymentErrorProps {
  error: string;
}

export const PaymentError = ({ error }: PaymentErrorProps) => {
  const { t } = useTranslation("translations");

  const getErrorMessage = () => {
    switch (error) {
      case PaymentErrors.CUSTOMER_COUNTRY_NOT_ALLOWED:
        return t("web_auth_error_signup_customer_country_not_allowed");
      case PaymentErrors.COUPON_CODE_INVALID:
        return t("web_offer_voucher_error");
      case PaymentErrors.POST_SUBSCRIPTION_SWITCHES__PAYMENT_METHOD_NOT_FOUND:
        return t("web_change_subscription_error_no_payment");
      default:
        return t("web_generic_error_header");
    }
  };

  return <p className={styles.error}>{getErrorMessage()}</p>;
};
